import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, RepeatableSummary, Step } from '../SteppedForm';

const StepPartners = (props) => {
  return (
    <Step
      id="partners"
      title="Additional Applicants"
      nonext
      skip={(formdata) =>
        formdata.orgtype === 'individual' || formdata.onboardingFor === 'vehicle'
      }>
      <RepeatableSummary
        jumpTo={(idx) => props.setState({ applicant_index: idx }, () => props.jumpTo('personal'))}
        getRow={(data) => ({
          Name: data.firstname + ' ' + data.surname,
          Phone: data.mobile,
          Address: data.home && data.home.description ? data.home.description : data.home
        })}
        getName={(data) => data.firstname + ' ' + data.surname}
        canDelete={(i) => props.state.formdata.applicants.length > 1}
      />
      <Typography variant="body1" class="formQuestion">
        Are there additional {props.state.formdata.orgtype === 'company' ? 'directors' : 'partners'}{' '}
        in your {props.state.formdata.orgtype === 'company' ? 'company ' : 'business partnership'}?
      </Typography>
      {props.state.formdata.orgtype === 'partnership' &&
      props.state.formdata.applicants.length === 1 ? (
        <ButtonField
          onClick={() => {
            props.setState(
              {
                formdata: {
                  ...props.state.formdata,
                  applicants: [...props.state.formdata.applicants, {}]
                },
                applicant_index: props.state.formdata.applicants.length
              },
              () => props.jumpTo('personal')
            );
          }}
          label="Add 2nd partner"
        />
      ) : (
        <>
          <ButtonField
            onClick={() => {
              props.setState(
                {
                  formdata: {
                    ...props.state.formdata,
                    applicants: [...props.state.formdata.applicants, {}]
                  },
                  applicant_index: props.state.formdata.applicants.length
                },
                () => props.jumpTo('personal')
              );
            }}
            label="Yes"
            className="TopIconButton"
            startIcon={<CheckOutlinedIcon />}
          />
          <ButtonField label="No" className="TopIconButton" startIcon={<ClearOutlinedIcon />} />
        </>
      )}
    </Step>
  );
};

export default StepPartners;
